import axios from '../axios';
import { GET_ORDERS_API, UPDATE_ORDER_STATUS } from '../ApiUrl';

export const getOrdersAPI = async (payload) => {
  try {
    const response = await axios.post(GET_ORDERS_API, payload);
    return response;
  } catch (error) {
    console.log('getOrdersAPI catch block', error);
    return { success: false, error };
  }
};

export const updateOrderStatusAPI = async (payload) => {
  try {
    const response = await axios.put(UPDATE_ORDER_STATUS, payload);
    return response;
  } catch (error) {
    console.log('updateOrderStatusAPI catch block', error);
    return { success: false, error };
  }
};
